import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getDocumentStatus } from '../../api/documentApi';
import Spinner from '../../components/spinner';

const StartPage: FC = () => {
  const navigate = useNavigate();
  const { documentId } = useParams();
  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    if (!documentId) {
      navigate('/failed');
      return;
    }

    getDocumentStatus(documentId)
      .then((status) => {
        if (status.status === 'SIGNED') {
          navigate(`/success/${documentId}`);
        } else {
          navigate(`/receipt/${documentId}`);
        }
      })
      .catch(() => {
        setSpinner(false);
        navigate('/failed');
      });
  }, [documentId, navigate]);

  return <>{spinner && <Spinner fullPage={true} />}</>;
};

export default StartPage;
